module.exports = __webpack_public_path__ + "img/40_83.49b498ba.png";